module.exports = __webpack_public_path__ + "static/img/phone.b3ed90ec.svg";